module.exports = __webpack_public_path__ + "media/images/icon-map-fb9e07d354cf28d72f995d056fa1e2d8.svg";